<div class="list-table" [ngClass]="{'card-container-shadow': !this.withoutContainer}" #containerRefProtein>

  <div class="title-label mb-xlg text-subtitle-bold-upper">
    <p id="micro-title">{{ title }}</p>
    <p id="micro-description" class="text-info text-lower-initial mt-xxs">{{ description }}</p>
    <div id="micro-values" class="text-info text-lower-initial tw-flex tw-items-center tw-mt-5">
      <p class="truncate" nz-popover="" nzPopoverTitle="" [nzPopoverContent]="'Selecciona el DDR de acuerdo al paciente'">Selecciona el DDR de acuerdo al
        paciente:</p>
      <nz-select [(ngModel)]="strategyName" nzBorderless nzShowSearch (ngModelChange)="onChangeStrategy()">
        <nz-option [nzValue]="DDRTypeEnum.LACTATINGMOTHER18" [nzLabel]="DDRTypeEnum.LACTATINGMOTHER18 | getTranslateEnum:'ddrStrategy'"></nz-option>
        <nz-option [nzValue]="DDRTypeEnum.LACTATINGMOTHER1930" [nzLabel]="DDRTypeEnum.LACTATINGMOTHER1930 | getTranslateEnum:'ddrStrategy'"></nz-option>
        <nz-option [nzValue]="DDRTypeEnum.LACTATINGMOTHER3150" [nzLabel]="DDRTypeEnum.LACTATINGMOTHER3150 | getTranslateEnum:'ddrStrategy'"></nz-option>
        <nz-option [nzValue]="DDRTypeEnum.PREGNANT18" [nzLabel]="DDRTypeEnum.PREGNANT18 | getTranslateEnum:'ddrStrategy'"></nz-option>
        <nz-option [nzValue]="DDRTypeEnum.PREGNANT1930" [nzLabel]="DDRTypeEnum.PREGNANT1930 | getTranslateEnum:'ddrStrategy'"></nz-option>
        <nz-option [nzValue]="DDRTypeEnum.PREGNANT3150" [nzLabel]="DDRTypeEnum.PREGNANT3150 | getTranslateEnum:'ddrStrategy'"></nz-option>
        <nz-option [nzValue]="DDRTypeEnum.MEN913" [nzLabel]="DDRTypeEnum.MEN913 | getTranslateEnum:'ddrStrategy'"></nz-option>
        <nz-option [nzValue]="DDRTypeEnum.MEN1418" [nzLabel]="DDRTypeEnum.MEN1418 | getTranslateEnum:'ddrStrategy'"></nz-option>
        <nz-option [nzValue]="DDRTypeEnum.MEN1930" [nzLabel]="DDRTypeEnum.MEN1930 | getTranslateEnum:'ddrStrategy'"></nz-option>
        <nz-option [nzValue]="DDRTypeEnum.MEN3150" [nzLabel]="DDRTypeEnum.MEN3150 | getTranslateEnum:'ddrStrategy'"></nz-option>
        <nz-option [nzValue]="DDRTypeEnum.MEN5170" [nzLabel]="DDRTypeEnum.MEN5170 | getTranslateEnum:'ddrStrategy'"></nz-option>
        <nz-option [nzValue]="DDRTypeEnum.MEN70" [nzLabel]="DDRTypeEnum.MEN70 | getTranslateEnum:'ddrStrategy'"></nz-option>
        <nz-option [nzValue]="DDRTypeEnum.WOMAN913" [nzLabel]="DDRTypeEnum.WOMAN913 | getTranslateEnum:'ddrStrategy'"></nz-option>
        <nz-option [nzValue]="DDRTypeEnum.WOMAN1418" [nzLabel]="DDRTypeEnum.WOMAN1418 | getTranslateEnum:'ddrStrategy'"></nz-option>
        <nz-option [nzValue]="DDRTypeEnum.WOMAN1930" [nzLabel]="DDRTypeEnum.WOMAN1930 | getTranslateEnum:'ddrStrategy'"></nz-option>
        <nz-option [nzValue]="DDRTypeEnum.WOMAN3150" [nzLabel]="DDRTypeEnum.WOMAN3150 | getTranslateEnum:'ddrStrategy'"></nz-option>
        <nz-option [nzValue]="DDRTypeEnum.WOMAN5170" [nzLabel]="DDRTypeEnum.WOMAN5170 | getTranslateEnum:'ddrStrategy'"></nz-option>
        <nz-option [nzValue]="DDRTypeEnum.WOMAN70" [nzLabel]="DDRTypeEnum.WOMAN70 | getTranslateEnum:'ddrStrategy'"></nz-option>
      </nz-select>
    </div>
  </div>
  <nz-list class="list" *ngIf="data.length> 0 && !loading">
    <div class="row header">
      <div class="column cursor-pointer" (click)="onSortByProperty('name')">
        <span class="mr-xxs">NOMBRE </span>
        <i nz-icon nzType="caret-up" nzTheme="outline" *ngIf="typeSort === 'ASC' && propertySort === 'name'"></i>
        <i nz-icon nzType="caret-down" nzTheme="outline" *ngIf="typeSort === 'DESC' && propertySort === 'name'"></i>
      </div>
      <div class="column cursor-pointer" (click)="onSortByProperty('value')">
        <span class="mr-xxs">VALOR </span>
        <i nz-icon nzType="caret-up" nzTheme="outline" *ngIf="typeSort === 'ASC' && propertySort === 'value'"></i>
        <i nz-icon nzType="caret-down" nzTheme="outline" *ngIf="typeSort === 'DESC' && propertySort === 'value'"></i>
      </div>
      <div class="column cursor-pointer" (click)="onSortByProperty('ddr')">
        <span class="mr-xxs">DDR </span>
        <i nz-icon nzType="caret-up" nzTheme="outline" *ngIf="typeSort === 'ASC' && propertySort === 'ddr'"></i>
        <i nz-icon nzType="caret-down" nzTheme="outline" *ngIf="typeSort === 'DESC' && propertySort === 'ddr'"></i>
      </div>
    </div>
    <ng-container *ngFor="let item of data; index as i">
      <div [@collapse]="showMoreMicronutrients || item.value> 0">
        <nz-list-item [class.mt-xs]="i === 0">
          <div class="row">
            <div class="column text-capitalize">
              <p class="truncate">{{ item.name }}</p>
            </div>
            <div class="column">
              <p>{{ item.value && item.value !== 0 ? item.value : '-' }} <span *ngIf="item.value && item.value !== '-' && item.value !== 0">{{
                  item.unitMeasurement }}</span></p>
            </div>
            <div class="column ddr-value">
              <p [ngClass]="{'greater-that-ddr': item.value> item.ddr, 'less-that-ddr': item.value <item.ddr,
                  'equal-that-ddr': item.value === item.ddr}">
                  {{ item.ddr ? (item.ddr + ' ' + item.unitMeasurement) : '-'}}
                </p>
                <i *ngIf="item.ddr" nz-popover="" nzPopoverTitle=""
                  [nzPopoverContent]="descriptionTpl" style="font-size: 15px; cursor: pointer;" nz-icon nzType="info-circle" nzTheme="twotone"></i>
                <ng-template #descriptionTpl>
                  <div class="content-description">
                    <p>
                      El valor de {{ item.name }}
                      {{ (item.value > item.ddr) ? 'excede el valor DDR ' + item.difference + ' ' + item.unitMeasurement :
                      (item.value <(item.ddr)) ? ' es ' + item.difference + ' ' + item.unitMeasurement + ' más bajo que el valor DDR' : 'corresponde correctamente con el DDR' }}
                    </p>
                  </div>
                </ng-template>
              </div>
            </div>
          </nz-list-item>
          <nz-divider></nz-divider>
        </div>
      </ng-container>
      <div class="mt-md tw-w-full d-flex justify-content-center align-items-center flex-column" style="gap: 0.5rem">
        <span class="text-info-bold-xs">{{ !showMoreMicronutrients ? 'MOSTRAR MÁS' : 'OCULTAR' }}</span>
        <button
          (click)="onShowHideMoreMicronutrients()"
          nz-button
          [class.add-category-btn]="btnMoreStyle === 'small'">
          <i nz-icon class="d-flex " [nzType]="!showMoreMicronutrients ? 'down' : 'up'" nzTheme="outline" style="font-size: 11px;"></i>
        </button>
      </div>
    </nz-list>
    <div class="loading-nutrients" *ngIf="loading" [ngStyle]="{'height': loadingHeight + 'px'}">
      <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 37 }"></nz-skeleton>
    </div>
    <div *ngIf="data.length === 0" class="empty-ingredients-charts" style="height: 200px;">
      <span class="text-info">{{ emptyText }}</span>
    </div>
  </div>
